'use client';

import { createContext, type ReactNode, useRef } from 'react';
import type { StoreApi } from 'zustand';
import { createSelectors, type StoreSelectors } from '../helpers';
import { createCommonStore } from '.';
import type { CommonStoreType } from './types';

export type CommonStoreApi = StoreApi<CommonStoreType>;

export const CommonStoreContext = createContext<CommonStoreRef | undefined>(
  undefined
);

export interface CommonStoreProviderProps {
  children: ReactNode;
  preloadedState?: Partial<CommonStoreType>;
}

interface CommonStoreRef {
  store: StoreApi<CommonStoreType>;
  selectors: StoreSelectors<StoreApi<CommonStoreType>>;
}

export const CommonStoreProvider = ({
  children,
  preloadedState,
}: CommonStoreProviderProps) => {
  const storeRef = useRef<CommonStoreRef | null>(null);

  if (storeRef.current === null) {
    const store = createCommonStore(preloadedState);
    const selectors = createSelectors(store);
    storeRef.current = { store, selectors };
  }

  return (
    <CommonStoreContext.Provider value={storeRef.current}>
      {children}
    </CommonStoreContext.Provider>
  );
};
